// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3SWXl","content":"Consent_content__32m_K","footer":"Consent_footer__2Oyc3"};